import React, { useEffect, useState } from 'react';
import { validation } from '../../../shared/form-validations';
import { textInput } from '../../../shared/form-elements'
import { connect } from 'react-redux';
import { reduxForm, Field, change, formValueSelector } from "redux-form";
import { Button } from 'react-bootstrap';
import { ContentLabel } from '../../../components';

function LabelForm(props) {
  const { handleSubmit, changeMode, name, colorHex, labelId, formMode, onDelete  } = props
  return (
    <form onSubmit={handleSubmit}>
      <div className='back-btn cursor-pointer mb-3' onClick={changeMode}>
        &lt; Back
      </div>
      <div>
        <ContentLabel 
          name={!!name ? name : "Enter label name"} 
          color_hex={!!colorHex ? colorHex : "dddddd"} 
          className={'content-label-selector__details non-editable for-display-only'}
          containerClassName={'w-100'}
          centered={true}
        />

        <Field
          name="name"
          type="text"
          autoFocus
          label="Label Name"
          component={textInput}
        />
      </div>
      <div className='mb-2'>
        <Field
          name="color_hex"
          type="text"
          label="Color HEX"
          component={textInput}
        />
      </div>
      <div className="d-grid">
        <Button
          variant="success"
          type="submit"
          className='mb-6px fw-500'
          size={'sm'}
        >
          Save
        </Button>
        <Button
          onClick={formMode === "edit_mode" ? (e) => onDelete(labelId, e) : changeMode }
          variant="white"
          style={{fontSize: 14}}
          className='border-0 fw-500'
          size={'sm'}
        >
          {formMode === "edit_mode" ? "Delete" : "Cancel"}
        </Button>
      </div>
    </form>
  );
}

LabelForm =  reduxForm({
  form: 'content_label_form',
  validate: validation,
  enableReinitialize : true,
})(LabelForm);

const contentLabelFormSelector = formValueSelector('content_label_form')
LabelForm = connect(state => {
  const name = contentLabelFormSelector(state, 'name')
  const colorHex = contentLabelFormSelector(state, 'color_hex')

  return {
    name,
    colorHex
  }
})(LabelForm);

export default LabelForm;
